import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'militaryTo12Hour',
  standalone: false,
})
export class MilitaryTo12HourPipe implements PipeTransform {
  transform(time: string): string {
    const [hours, minutes] = time.split(':');

    // Convert hours to 12-hour format
    let hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;

    const formattedTime = `${hour}:${minutes} ${ampm}`;

    return formattedTime;
  }
}
